/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteEnvironmentReleasePlanPathParams = NonNullable<
  operations['DeleteEnvironmentReleasePlan']['parameters']['path']
>;

export interface Input extends DeleteEnvironmentReleasePlanPathParams {
  apiVersion?: string;
  header: NonNullable<operations['DeleteEnvironmentReleasePlan']['parameters']['header']>;
}

export async function DeleteEnvironmentReleasePlan(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE(
    '/api/v2/projects/{projectKey}/environments/{environmentKey}/release-plans/{releasePlanKey}',
    {
      params: { path, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
